import { z } from 'zod';
import { LEVELS, ROLES, CATEGORIES, define, DEFINITION_KINDS } from '../types.js';

/**
 * Private/internal config with freeform structure.
 */
export const schema = z.record(z.unknown());

export type Private = z.infer<typeof schema>;

export const definition = define({
  key: 'private',
  schema,
  label: 'Private',
  description: 'Private/internal config. Freeform structure with dynamic boolean toggles for data sharing.',
  kind: DEFINITION_KINDS.SETTING,
  category: CATEGORIES.PRIVATE.key,
  writableAtLevels: [
    LEVELS.HOPDRIVE,
    LEVELS.REGION,
    LEVELS.ORGANIZATION,
    LEVELS.CUSTOMER,
    LEVELS.WORKFLOWSET,
    LEVELS.RATERULEGROUP,
    LEVELS.MOVE,
  ],
  readableByRoles: [ROLES.ADMIN],
});
